export default {
    // payModel
    wechatpay: "微信支付",
    card: "会员卡",
    alipay: "支付宝",
    wallet: "余额",
    cash: "现金",
    pos: "刷卡",
    other: "其他",

    //channel
    miniProgram: "微信小程序",
    web: "电脑网页",

    // status
    noPaid: "未支付",
    notConfirmed: "待付款",
    confirmed: "待使用",
    closed: "已关闭",
    completed: "已完成",
    canceled: "已取消"
};
